import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../api.service';
// import { Router } from '@angular/router'; 

@Component({
  selector: 'app-vender-signup',
  templateUrl: './vender-signup.component.html',
  styleUrls: ['./vender-signup.component.scss']
})
export class VenderSignupComponent implements OnInit {

  venderForm: FormGroup;
  public submitted = false;
  public cPassword = false;
  public message = '';
  public durationType = 'monthly';

  constructor(private formBuilder: FormBuilder,private apiService: ApiService,
    // private router: Router
  ) {}

  get f() { return this.venderForm.controls; }

  ngOnInit(): void {
    this.venderForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]],
      confirmPassword: ['', Validators.required],
    });
  }

  submitForm(){
    this.submitted = true;
    this.cPassword = false;
    // stop here if form is invalid
    if (this.venderForm.invalid) {
        return;
    }else if(this.venderForm.value.password != this.venderForm.value.confirmPassword){
      this.cPassword = true;
    }else{
      let email = this.venderForm.value.email;
      let data = this.venderForm.value;
      let url = 'vendor/vendorsignup';
      this.apiService.postVenderSignup(url, data).subscribe((response) => {
        if(response.success){
          localStorage.setItem('venderToken',response.token);
          let paymentData = {
            "durtype": this.durationType,
            "occurtype": "recursive",
            "uniqueKey": "my-app-vendor",
            "email":email?email:''
          }
          let paymentURL = 'billingservice/vendorsubscription/payment';
          this.apiService.postvenderSignupPayment(paymentURL,paymentData).subscribe((res)=>{
            window.location.href = res.redirectUrl
          });
        }else{
          this.message = response.message;
          setTimeout(()=>{
            this.message = '';
          },5000)
        }
      },
      );
    }
  }

  getDurationType(duration){
    this.durationType = duration;
  }
}
